import { useEffect, useState, useRef } from "react";
import banner from "../assets/images/bannerRollerCoin.gif";
import iconCoinz from "../assets/images/logo192.png";
import iconOptions from "../assets/images/options.png";
import iconEstimation from "../assets/images/estimation.png";
import iconUser from "../assets/images/user.png";

export const Header = ({ title, balance, optionsOwned, estimatedWeeklyGain }) => {
  const coinzToUSD = (coinz) => (coinz * 0.00001).toFixed(4);
  const formatCoinz = (value) => value.toLocaleString("en-US");

  const getNextDividendCountdown = () => {
    const now = new Date();
    const next = new Date(now);
  
    // On calcule combien de jours pour atteindre dimanche
    const dayOfWeek = now.getDay(); // 0 = dimanche
    let daysUntilSunday = (7 - dayOfWeek) % 7;
  
    // Si aujourd'hui est dimanche, on doit vérifier l'heure :
    if (dayOfWeek === 0) {
      if (now.getHours() < 23 || (now.getHours() === 23 && now.getMinutes() < 30)) {
        daysUntilSunday = 0; // Aujourd'hui mais pas encore 23:30
      } else {
        daysUntilSunday = 7; // Trop tard : prochain dimanche
      }
    }
  
    // Fixe la date au prochain dimanche à 23:30:00
    next.setDate(now.getDate() + daysUntilSunday);
    next.setHours(23, 30, 0, 0);
  
    const diffMs = next - now;
    const totalSeconds = Math.max(Math.floor(diffMs / 1000), 0);
  
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
  
    return `${days}d ${String(hours).padStart(2, "0")}h ${String(minutes).padStart(2, "0")}m ${String(seconds).padStart(2, "0")}s`;
  };

  const [countdown, setCountdown] = useState(getNextDividendCountdown());

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(getNextDividendCountdown());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // --- Dropdown menu state and ref
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef();

  // Close menu if click outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="bg-gray-900 text-white px-4 sm:px-6 py-4 rounded shadow relative">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <h1 className="text-lg sm:text-xl font-semibold truncate">{title}</h1>

        <div className="flex-1 flex justify-center">
          <a
            href="https://rollercoin.com/?r=m9ct3rj8"
            target="_blank"
            rel="noopener noreferrer"
            className="block"
          >
            <img
              src={banner}
              alt="Banner"
              className="max-w-full h-12 sm:h-14 object-contain rounded-lg shadow"
            />
          </a>
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center sm:gap-6 text-xs sm:text-sm text-gray-300 text-right sm:text-left">
        <a href="/usersettings" title="Get more information">
          <div className="flex flex-wrap items-center justify-end sm:justify-start gap-3">
           
            <div className="flex items-center gap-1">
              <img src={iconCoinz} alt="Coinz Icon" className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>{formatCoinz(Number(balance))} Coinz</span>
            </div>
            <div className="flex items-center gap-1">
              <img src={iconOptions} alt="Options Icon" className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>{formatCoinz(optionsOwned)} options owned</span>
            </div>
            <div className="flex items-center gap-1">
              <img src={iconEstimation} alt="Estimation Icon" className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>+{formatCoinz(Math.round(estimatedWeeklyGain))}/week</span>
            </div>
          </div>
        </a>
        <a href="/marketplace" title="Increase your profit with options">
          <div className="text-[11px] text-green-300 mt-1 sm:mt-0">
            Next dividends in: <span>{countdown}</span>
          </div>
        </a>

          {/* Dropdown */}
          <div className="relative ml-4" ref={menuRef}>
            <button
              onClick={() => setMenuOpen((open) => !open)}
              aria-haspopup="true"
              aria-expanded={menuOpen}
              className="flex items-center justify-center w-8 h-8 rounded-full border border-gray-600 overflow-hidden hover:opacity-80 transition"
              type="button"
            >
              <img src={iconUser} alt="User Icon" className="w-full h-full object-cover" />
            </button>

            {menuOpen && (
              <div className="absolute right-0 mt-2 w-40 bg-gray-800 rounded shadow-md z-50">
                <ul className="text-sm text-gray-100 divide-y divide-gray-700">
                  
                  <li>
                    <a
                      href="/usersettings"
                      className="block px-4 py-2 hover:bg-gray-700 transition"
                      onClick={() => setMenuOpen(false)}
                    >
                      Profile
                    </a>
                  </li>
                  <li>
                    <a
                      href="/withdraw"
                      className="block px-4 py-2 hover:bg-gray-700 transition"
                      onClick={() => setMenuOpen(false)}
                    >
                      Withdraw
                    </a>
                  </li>                
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};
